module.exports = __webpack_public_path__ + "img/logo.a7a3cf6e.png";